import queryKeys from '@/constants/queryKeys';
import { orgScoreDataGet } from '@/services/api/requests/public-screener';
import { useQuery } from '@tanstack/react-query';

const usePublicScreenerOrgScoreData = ({ slug, enabled }: { slug: string; enabled: boolean }) => {

  const { isLoading, data, isError, error, isRefetching, refetch, isSuccess } = useQuery({
    queryKey: [queryKeys.publicScreener.orgAverageScore, slug],
    enabled,
    queryFn: async () => {
      if (!slug) {
        throw new Error('Organization slug and Turnstile token are required');
      }

      const response = await orgScoreDataGet(slug);

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch, isSuccess };
};

export default usePublicScreenerOrgScoreData;
